import { API_BASE_URL } from "@/config";
import { handle_registration_redirect } from '@/utils/redirects';
import { MAIN_CONTROLLER } from '@/utils/main_controller';

export default {
  name: 'UserLogin',
  mixins: [MAIN_CONTROLLER],
  data: () => ({
    username: '',
    password: '',
    show_password: false,
    client_admin_id: sessionStorage.getItem('client_admin_id'),
    workflow_id: sessionStorage.getItem('workflow_id'),
    asset_id: sessionStorage.getItem('asset_id'),
    reset_url: `${API_BASE_URL}/verify_api/password_reset/`
  }),

  created() {
    // Add client detection logic
    const domain = window.location.hostname;

    if (domain.includes("verify")) {
      this.client = "verify";
    } else if (domain.includes("wizzit")) {
      this.client = "wizzit";
    } else if (domain.includes("mobiafrica")) {
      this.client = "mobiafrica";
    } else if (domain.includes("vodacom")) {
      this.client = "vodacom";
    } else if (domain.includes("weelee")) {
      this.client = "weelee";
    } else if (domain.includes("nutun")) {
      this.client = "nutun";
    } else if (domain.includes("nurturelink")) {
      this.client = "nurturelink";
    } else if (domain.includes("suzuki")) {
      this.client = "suzuki";
    }  else if (domain.includes("veersgroup")) {
      this.client = "veersgroup";
    } else if (domain.includes("eaglecorner")) {
      this.client = "eaglecorner";
    } else if (domain.includes("hybridconcepts")) {
      this.client = "hybridconcepts";
    } else if (domain.includes("eeb")) {
      this.client = "eeb";
    } else if (domain.includes("miway")) {
      this.client = "miway";
    } else if (domain.includes("mfo")) {
      this.client = "mfo";
    } else if (domain.includes("ittsc")) {
      this.client = "ittsc";
    } else if (domain.includes("smartsure")) {
      this.client = "smartsure";
    } else if (domain.includes("experian")) {
      this.client = "experian";
    } else if (domain.includes("autocity")) {
      this.client = "autocity";
    } else if (domain.includes("yumbi")) {
      this.client = "yumbi";
    } else if (domain.includes("santam")) {
      this.client = "santam";
    } else if (domain.includes("altron")) {
      this.client = "altron";
    } else if (domain.includes("swift")) {
      this.client = "swift";
    } else if (domain.includes("webuycars")) {
      this.client = "webuycars";
    } else if (domain.includes("neutrinori")) {
      this.client = "neutrinori";
    } else if (domain.includes("getsavvi")) {
      this.client = "getsavvi";
    }

    // Set client-specific data attribute
    if (this.client) {
      document.documentElement.setAttribute("data-client", this.client);
    }
  },
  
  mounted() {
    const GET_CLIENT_ID = sessionStorage.getItem('client_admin_id');
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');

    if (token && user_id) {
      this.redirect(token, GET_CLIENT_ID);
    }
  },
  methods: {
    open_modal() {
      $('#login-modal').modal('show');
    },
    close_modal() {
      $('#login-modal').modal('hide');
    },
    toggle_password_view() {
      this.show_password = !this.show_password;
    },

    convert_email_to_lowercase() {
      if (this.username) {
          this.username = this.username.toLowerCase();
      }
    },

    redirect(token, GET_CLIENT_ID) {
      const CHECK_PROCESS_URL = `${API_BASE_URL}/verify_api/system_management_api/user_redirect_api/`;

      $.ajax({
        url: CHECK_PROCESS_URL,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${token}`
        },
        success: (response) => {
          handle_registration_redirect(
            response,
            this.$router,
            this.$store,
            this.fetch_current_service,
            GET_CLIENT_ID
          );
        },
        error: () => {
          return
        }
      })
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    normalizeToLocalFormat(phone) {
      if (!phone) return '';

      let cleaned = phone.replace(/[^\d]/g, '');

      if (cleaned.startsWith('27') && cleaned.length === 11) {
        return '0' + cleaned.substring(2);
      } else if (cleaned.startsWith('0') && cleaned.length === 10) {
        return cleaned;
      }

      return '';
    },

    isValidPhoneNumber(phone) {
      const cleaned = phone.replace(/[^\d]/g, '');
      return /^(27|0)\d{9}$/.test(cleaned);
    },

    showError(message) {
      $('.login-message').text(message).removeClass('d-none');
      setTimeout(() => {
        $('.login-message').text('').addClass('d-none');
      }, 3000);
    },

    login() {
      if (!this.username.trim()) {
        $('.username-message').removeClass('d-none');
        setTimeout(() => {
          $('.username-message').addClass('d-none');
        }, 3000);
        return false;
      }
      if (!this.password.trim()) {
        $('.password-message').removeClass('d-none');
        setTimeout(() => {
          $('.password-message').addClass('d-none');
        }, 3000);
        return false;
      }

      const GET_CLIENT_ID = sessionStorage.getItem('client_admin_id');      
      const LOGIN_URL = `${API_BASE_URL}/verify_api/system_management_api/login_api/`;

      const all_responses = [];

      let loginUsername = this.username?.trim();

      if (this.client === 'verify' && !this.isValidEmail(loginUsername)) {
        if (!this.isValidPhoneNumber(loginUsername)) {
          this.showError('Please enter a valid South African phone number');
          return;
        }

        const phone = this.normalizeToLocalFormat(loginUsername);
        loginUsername = `${phone}@tgpdc.com`;
      }

      const FORM_DATA = {
        client_id: GET_CLIENT_ID,
        username: loginUsername,
        password: this.password,
        responses: all_responses
      };
      const data_to_send = JSON.stringify(FORM_DATA);
      const content_type = 'application/json';

      $.ajax({
        url: LOGIN_URL,
        method: 'POST',
        data: data_to_send,
        processData: true,
        contentType: content_type,
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.close();
          
          // Check if first-time password reset is required
          if (response.status === 'first_time_password_reset_required') {
            sessionStorage.setItem('reset_email', response.email);
            sessionStorage.setItem('reset_user_id', response.user_id);
            
            Swal.fire({
              icon: 'info',
              title: 'Password Reset Required',
              text: response.message || 'Please reset your password on first login',
              confirmButtonText: 'Continue'
            }).then(() => {
              this.$router.push({ 
                name: 'first_time_password_reset',
                params: {
                  email: response.email,
                  user_id: response.user_id
                }
              });
            });
            return;
          }
          
          sessionStorage.clear();
          localStorage.clear();
          localStorage.setItem('user_id', response.user_id);
          this.$store.commit('set_user_role', response.user_role)
          
          localStorage.setItem('token', response.token);
          localStorage.setItem('user_state', 'logged_in');
          
          sessionStorage.setItem('client_admin_id', response.client_admin_id);
          
          if (this.workflow_id){
            sessionStorage.setItem('workflow_id', this.workflow_id);
          }

          if (this.asset_id){
            sessionStorage.setItem('asset_id', this.asset_id);
          }
          this.handleLogin();
        },
        error: (error) => {
          Swal.close();
          let error_message = 'Error Logging in';

          // Prefer structured error data when available
          if (error.responseJSON && error.responseJSON.error) {
            error_message = error.responseJSON.error;
          } else if (error.responseText) {
            try {
              const parsed = JSON.parse(error.responseText);
              if (parsed && parsed.error) {
                error_message = parsed.error;
              }
            } catch (_) {
              // responseText was not JSON (likely an HTML 500 page); fall back to status text
              if (error.statusText) {
                error_message = error.statusText;
              }
            }
          }

          $('.login-message').text(error_message).removeClass('d-none');
          setTimeout(() => {
            $('.login-message').text('').addClass('d-none');
          }, 3000);
        }
      });
    },
    handleLogin() {
      this.$router.push({ name: 'user_otp' });
    }
  }
};
